module.exports = __webpack_public_path__ + "static/media/Mail.928a5524.svg";